import NewsletterArchiveList from "@/components/newsletter/NewsletterArchiveList";
import { useNewsletterPosts } from "@/hooks/use-newsletter-posts";

type Props = {
  excludeSlug: string;
};

export default function NewsletterMoreIssues({ excludeSlug }: Props) {
  const { posts, loading, error } = useNewsletterPosts();
  const filtered = posts.filter((p) => p.slug !== excludeSlug);

  if (error) return null;
  if (!loading && filtered.length === 0) return null;

  return (
    <NewsletterArchiveList
      articleColumn
      posts={filtered}
      loading={loading}
      headingId="newsletter-more-issues-heading"
      eyebrow="All dispatches"
      title="More from Staying Ahead"
      description={null}
    />
  );
}